// extracted by mini-css-extract-plugin
export default {"howToUseImage":"styles_howToUseImage__XsJQ+","title":"styles_title__EfL2d"};